<template>
    <footer>
        <div class="footer-top">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <h6>RED AUTOS</h6>
                        <ul>
                            <li>
                                Red Autos S.A.S
                            </li>
                            <li>
                                NIT: 900.935.122
                            </li>
                            <li>
                                servicioalcliente@redautos.com
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <h6>SEDE CALLE 5</h6>
                        <ul>
                            <li>
                                <i
                                    class="fa fa-map-marker"
                                    aria-hidden="true"
                                ></i>
                                Calle 5 # 14 - 47 / Cali - Valle
                            </li>
                            <li>
                                <i
                                    class="fa fa-whatsapp"
                                    aria-hidden="true"
                                ></i>
                                318 827 4142
                            </li>
                        </ul>
                        <h6>Sede Calle 8</h6>
                        <ul>
                            <li>
                                <i
                                    class="fa fa-map-marker"
                                    aria-hidden="true"
                                ></i>
                                Calle 18 Norte # 7 - 17 / Cali - Valle
                            </li>
                            <li>
                                <i
                                    class="fa fa-whatsapp"
                                    aria-hidden="true"
                                ></i>
                                320 666 0716
                            </li>
                        </ul>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <ul>
                            <li><a href="/compra_de_usados">Comprar</a></li>
                            <li><a href="/vender">Vender</a></li>
                            <li><a href="/financiar">Financiar </a></li>
                            <li><a href="/acercade">¿Por qué Redautos?</a></li>
                            <li><a href="/servicios">Servicios</a></li>
                            <li><a href="/contacto">Contacto</a></li>
                        </ul>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <h6>Horario de Atención</h6>
                        <ul>
                            <li>
                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                                Lunes a Viernes 8am - 5pm
                            </li>
                            <li>
                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                                Sábados 9am - 4pm
                            </li>
                        </ul>
                        <div class="newsletter-form">
                            <a
                                type="submit"
                                class="btn btn-block"
                                href="/login"
                                arial-label="Ingreso para Aliados"
                            >
                                Ingreso para Aliados
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-md-push-6 text-right">
                        <div class="footer_widget">
                            <p>Siguenos en:</p>
                            <ul>
                                <li>
                                    <a
                                        href="https://wa.link/axe8kp"
                                        target="blank"
                                        aria-label="Contactar por Whatsapp"
                                    >
                                        <i
                                            class="fa fa-whatsapp"
                                            aria-hidden="true"
                                        ></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.facebook.com/RedAutos-105199845218138"
                                        target="blank"
                                        aria-label="Visítanos en Facebook"
                                    >
                                        <i
                                            class="fa fa-facebook-square"
                                            aria-hidden="true"
                                        ></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="http://instagram.com/redautos"
                                        target="blank"
                                        aria-label="Visítanos en Instagram"
                                    >
                                        <i
                                            class="fa fa-instagram"
                                            aria-hidden="true"
                                        ></i>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://twitter.com/redautosco"
                                        target="blank"
                                        aria-label="Visítanos en Twitter"
                                    >
                                        <i
                                            class="fa fa-twitter-square"
                                            aria-hidden="true"
                                        ></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-md-pull-6">
                        <p class="copy-right">
                            Copyright &copy; 2024 Redautos. Todos los derechos reservados.
                        </p>
                    </div>
                    <div class="col-md-12 text-center">
                       <a href="https://www.avaluauto.com/"  class="text-muted" target="_blank">Powered by Avaluauto</a>
                    </div>
                </div>
            </div>
        </div>
        <iconoFlotante />
    </footer>
</template>

<script>
import iconoFlotante from "./iconFlotante";

export default {
    components: {
        iconoFlotante
    }
};
</script>

<style lang="scss" scoped></style>
